const $$splitComponentImporter = () => import('/home/ubuntu/actix-web-dome/ui/src/apps/main/routes/_main/admin/sms/send-log.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { SmsLogFilterParamSchema } from '@apps/main/features/admin/pages/sms/send-log-schema';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_main/admin/sms/send-log')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: SmsLogFilterParamSchema
});